import { render, staticRenderFns } from "./EducationEnquiry.vue?vue&type=template&id=310b4886&scoped=true&"
import script from "./EducationEnquiry.vue?vue&type=script&lang=js&"
export * from "./EducationEnquiry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310b4886",
  null
  
)

export default component.exports